import { getEnvs } from './env'

export const preferExample = <T>(exampleId: T) =>
  getEnvs().mockedBackend
    ? {
        Prefer: `example=example-${exampleId}`,
      }
    : undefined
